const capitalizeFirstLetter = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

export const listParser = (list: { id: number; value: string }[]) =>
  list.map(({ id, value }) => ({ label: capitalizeFirstLetter(value), value: id.toString() }))
